import axios from "axios";
import { showToast } from 'vant';
import router from "@/router";
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers["Accesse-Control-Allow-Origin"] = "*";
// 创建axios实例
const baseURL = process.env.VUE_APP_BASE_URL
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: baseURL+ '/api/', // 此处的 /admin-api/ 地址，原因是后端的基础路径为 /admin-api/
  // 超时
  timeout: 20000,
});
const toWxLogin = () => {
  localStorage.removeItem('token')
  router.push({name: 'loginWx', query: {redirect: window.location.pathname + window.location.search}})
}
// request拦截器
service.interceptors.request.use(
  (config) => {
    config.headers["token"] = localStorage.getItem('token') // 让每个请求携带自定义token 请根据实际情况自行修改
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 20000;
    // 获取错误信息
    const msg =  res.data.msg
    if (code === 401) {
      showToast("登录状态已过期")
      toWxLogin()
    } else if (code === 500) {
      showToast(msg);
      return Promise.reject(new Error(msg));
    } else if (code !== 20000) {
      showToast(msg);
      return Promise.reject("error");
    } else {
      return res.data;
    }
  },
  (error) => {
    const data = error.response && error.response.data;
    if (data && data.code === 401) {
      showToast("登录状态已过期")
      toWxLogin()
      return Promise.reject("无效的会话，或者会话已过期，请重新登录。");
    }
    // 接口返回 code=40000 等业务错误时，显示后端返回的 msg
    if (data && data.code === 40000) {
      showToast(data.msg || "操作失败");
      return Promise.reject(data.msg || "error");
    }
    let { message } = error;
    if (message === "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "无权限访问";
    }
    showToast(message);
    return Promise.reject(error);
  }
);
export default service;
